var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"py-2 bg-white rounded-full text-sm px-4 text-center whitespace-nowrap",attrs:{"to":'/search?q=' + encodeURIComponent(_vm.text)}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }